"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHolderStatus = exports.IssuingCardStatus = exports.BalanceTransactionType = void 0;
var BalanceTransactionType;
(function (BalanceTransactionType) {
    BalanceTransactionType["payout"] = "payout";
    BalanceTransactionType["scheduled_payout"] = "scheduled_payout";
    BalanceTransactionType["payment"] = "payment";
    BalanceTransactionType["payment_refund"] = "payment_refund";
    BalanceTransactionType["issuing_authorization_hold"] = "issuing_authorization_hold";
    BalanceTransactionType["issuing_transaction"] = "issuing_transaction";
    BalanceTransactionType["issuing_dispute"] = "issuing_dispute";
    BalanceTransactionType["topup"] = "topup";
    BalanceTransactionType["pending_topup"] = "pending_topup";
})(BalanceTransactionType || (exports.BalanceTransactionType = BalanceTransactionType = {}));
var IssuingCardStatus;
(function (IssuingCardStatus) {
    IssuingCardStatus["Active"] = "Active";
    IssuingCardStatus["Inactive"] = "Inactive";
    IssuingCardStatus["Pending"] = "Pending";
    IssuingCardStatus["Canceled"] = "Canceled";
})(IssuingCardStatus || (exports.IssuingCardStatus = IssuingCardStatus = {}));
var CardHolderStatus;
(function (CardHolderStatus) {
    CardHolderStatus["Active"] = "Active";
    CardHolderStatus["Inactive"] = "Inactive";
    CardHolderStatus["Blocked"] = "Blocked";
})(CardHolderStatus || (exports.CardHolderStatus = CardHolderStatus = {}));
